import { render, staticRenderFns } from "./bet-list.vue?vue&type=template&id=088c6e08"
import script from "./bet-list.vue?vue&type=script&lang=js"
export * from "./bet-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('088c6e08')) {
      api.createRecord('088c6e08', component.options)
    } else {
      api.reload('088c6e08', component.options)
    }
    module.hot.accept("./bet-list.vue?vue&type=template&id=088c6e08", function () {
      api.rerender('088c6e08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/bet-list.vue"
export default component.exports